<template>
    <div id="main" ref="modalAparelhos" :style="{ height: `${heightModal}px` }">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="columns">
            <div v-if="tipo == 0" class="column is-full has-text-justified">
                <p v-html="$t('inativar-aparelho', { n: aparelho.imei })"></p>
                <p v-html="this.$t('atencao-desativar-aparelho')"></p>
            </div>

            <div v-else class="column is-full">
                <div class="columns">
                    <div class="column is-full has-text-justified">
                        <p  
                            v-if="!isAparelhoJupiter"
                            v-html="
                                $t('msg-ativar-aparelho', {n: aparelho.imei, v: aparelho.login })
                            "
                        ></p>
                        <p
                            v-else
                            v-html="
                                $t('msg-ativar-aparelho-sem-usuario', {n: aparelho.imei})
                            "
                        >
                        </p>
                    </div>
                </div>
                <div v-if="dataAtivacao" class="columns">
                    <div class="column is-full has-text-justified">
                        <p
                            style="color: red"
                            v-html="$t('data-ativacao', { n: dataAtivacao })"
                        ></p>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-half has-text-justified">
                        <span>{{ $t('alteracao-imei') }}</span>
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('tooltip-troca-imei')"
                        />
                    </div>
                    <div class="column is-half">
                        <div class="ml-1">
                            <b-switch
                                v-model="booleanImei"
                                :title="booleanImei ? $t('ativado') : $t('desativado')"
                                :disabled="booleanImeiDisabled"
                            >
                                <span v-if="booleanImei">
                                    {{ $t('sim') }}
                                </span>
                                <span v-else>
                                    {{ $t('nao') }}
                                </span>
                            </b-switch>
                        </div>
                    </div>
                </div>
                <div v-if="booleanImei" class="columns">
                    <div class="column is-full has-text-justified">
                        <p v-html="this.$t('msg-registro-aparelho-substituido')"></p>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-full">
                        <div class="situacao-select">
                            <label v-text="$t('lista-aparelhos')" />
                            <v-select
                                ref="selectImei"
                                class="is-100"
                                label="label"
                                :options="listaAtivos"
                                v-model="imeiSelecionado"
                                :clearable="true"
                                :disabled="!booleanImei"
                                :searchable="true"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.usuario }} - {{ option.label }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                                <template slot="no-options">{{
                                    $t('sem-resultados')
                                }}</template>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div v-if="!booleanImei" class="columns">
                    <div class="column is-full has-text-justified">
                        <p v-html="this.$t('msg-registro-ativo-mensalidade')"></p>
                    </div>
                </div>
                <div v-if="imeiSelecionado" class="columns">
                    <div class="column is-full has-text-justified">
                        <p v-html="this.$t('atencao-desativar-aparelho')"></p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-full has-text-justified">
                        <p
                            style="color: red; font-weight: bold;"
                            v-html="this.$t('atencao-desativar-aparelho-cobranca')"
                        ></p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-full has-text-justified">
                        <p v-html="this.$t('deseja-prosseguir-ativacao')"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full margin-auto" style="text-align: center">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="fechar()"
                    style="padding: 10px 20px"
                >
                    {{ $t('nao') }}
                </button>
                <button
                    class="save-btn ml-1"
                    type="button"
                    @click="save"
                    :disabled="isLoading"
                    style="padding: 10px 20px"
                >
                    {{ $t('sim') }}
                    <button-loader :isSaving="isLoading" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AparelhoService from '@/services/AparelhoService';
import AparelhoJupiterService from '@/services/AparelhoJupiterService';
import MMChaveLiberacaoService from '@/services/MMChaveLiberacaoService';

export default {
    props: {
        aparelho: {},
        tipo: {},
        isAparelhoJupiter: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            service: !this.isAparelhoJupiter ? new AparelhoService(this.$http, this.$router) : new AparelhoJupiterService(this.$http, this.$router),
            mm_service: new MMChaveLiberacaoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            heightModal: null,
            booleanImei: false,
            booleanImeiDisabled: false,
            imeiSelecionado: null,
            onChangeImei: null,
            listaAtivos: [],
            dataAtivacao: null,
        };
    },
    mounted() {
        this.carregarAtivos();
        if (this.tipo != 0) {
            this.carregarData();
        }
    },
    created() {},
    methods: {
        fechar() {
            this.$emit('fecharModal');
        },
        save() {
            if (this.booleanImei) {
                this.$emit('ativacaoInativacao', {
                    imeiOperacao: {
                        vendedor_id: this.aparelho.vendedor_id,
                        id: this.aparelho.idaparelho,
                        imei: this.aparelho.imei,
                        license_key: this.aparelho.license_key,
                        situacao: this.aparelho.situacao,
                        teste: this.aparelho.teste ? this.aparelho.teste : 'N',
                    },
                    imeiDesativacao: {
                        vendedor_id: this.imeiSelecionado.idvendedor,
                        id: this.imeiSelecionado.id,
                        imei: this.imeiSelecionado.label,
                        license_key: this.imeiSelecionado.license_key,
                        situacao: this.imeiSelecionado.situacao,
                        teste: 'N',
                    },
                    operacao: 'T',
                });
            } else {
                if (this.aparelho.situacao == 'A') {
                    this.$emit('ativacaoInativacao', {
                        imeiOperacao: {
                            vendedor_id: this.aparelho.vendedor_id,
                            id: this.aparelho.id,
                            imei: this.aparelho.imei,
                            license_key: this.aparelho.license_key,
                            situacao: this.aparelho.situacao,
                            teste: this.aparelho.teste ? this.aparelho.teste : 'N',
                        },
                        operacao: 'I',
                    });
                } else {
                    this.$emit('ativacaoInativacao', {
                        imeiOperacao: {
                            vendedor_id: this.aparelho.vendedor_id,
                            id: this.aparelho.id,
                            imei: this.aparelho.imei,
                            license_key: this.aparelho.license_key,
                            situacao: this.aparelho.situacao,
                            teste: this.aparelho.teste ? this.aparelho.teste : 'N',
                        },
                        operacao: 'A',
                    });
                }
            }
        },
        // @71530 - Carrega a lista de aparelhos ativos disponíveis para a troca
        carregarAtivos() {
            this.service
                .findActive(this.$store.state.user.idClienteSovis, this.order, this.column)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.idaparelho,
                            label: i.imei,
                            usuario: i.login,
                            idvendedor: i.vendedor_id,
                            license_key: i.license_key,
                            situacao: i.situacao,
                        };
                    });
                })
                .then((r) => {
                    this.listaAtivos = r;
                    this.listaAtivos.sort();
                });
        },
        // @71530 - Carregar última data que foi feita ativação ou troca
        carregarData() {
            this.mm_service.getData(this.aparelho.imei, this.aparelho.id).then((body) => {
                this.dataAtivacao = body.content != null ? this.$moment(body.content.datahorainc).format('L') : '';
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    width: 60%;
    padding: 20px 20px !important;
    background-color: $sovis-white;
    margin: auto;

    span {
        font-size: 13px;
    }

    .conteudo-parametrizacao {
        display: flex;
        align-items: center;
        padding: 20px 0px;
        flex-direction: column;

        .conteudo-parametrizacao-descricao {
            width: 70%;
        }

        .conteudo-parametrizacao-valor {
            display: flex;
            align-items: center;
            flex-direction: row;
            width: 80%;
            margin-top: 15px;
            //margin-bottom: 100px;

            span {
                margin-right: 10px;
            }

            div {
                width: 100%;
                margin-top: 5px;
            }
        }
    }
}
</style>
